<template>
  <section v-if="user.information">
    <div class="px-3">
      <div class="org-logo" v-if="user.information.organisation.image_uuid">
        <b-img :src="organisationImage"></b-img>
      </div>

      <div class="mt-4" v-if="!user.information.organisation.image_uuid">
        &nbsp;
      </div>

      <b-nav vertical class="mt-0">
        <b-nav-item :to="{ name: 'Dashboard' }" @click="clickedMenu"  id="menu_dashboard">
          <i class="fal fa-home"></i> {{ $t("DASHBOARD.TITLE") }}
        </b-nav-item>

        <b-nav-item :to="{ name: 'Messages' }" @click="clickedMenu" id="menu_messages"
          ><i class="fal fa-inbox"></i> {{ $t("MESSAGES.TITLE") }}
          <b-badge v-if="user.new_message != 0">{{
            user.new_message
          }}</b-badge></b-nav-item
        >

        <b-nav-item :to="{ name: 'Meetings' }" @click="clickedMenu"  v-if="meeting_enabled"
          ><i class="fal fa-video"></i> {{ $t("MEETINGS.TITLE") }}
        </b-nav-item>

        <b-nav-item @click="clickedMenu"  v-if="filestorage_enabled"
          :to="{ name: 'FileStorage' }"
          ><i class="fal fa-file"></i> {{ $t("FILESTORAGE.TITLE") }}
        </b-nav-item>

        <b-nav-item :to="{ name: 'Support' }" @click="clickedMenu"
          ><i class="fal fa-headset"></i> {{ $t("SUPPORT") }}</b-nav-item
        >
      </b-nav>
      <Footer></Footer>
    </div>
  </section>
</template>
<script>
import Footer from "@/components/Layout/MenuFooter";
export default {
  components: { Footer },
  data() {
    return {
      showMobile: false,
      meeting_enabled: false,
      filestorage_enabled: false
    };
  },
  methods: {
    async init() {
      await this.checkMeetings();
      await this.checkFilestorage();
    },    
    async checkMeetings(){
      if(this.user.information)
      {
        let self = this;
        await this.$http
          .get(this.user.hostname + "/meeting/enabled")
          .then(function(result) {
            self.meeting_enabled = result.data;
          })
          .catch(function() {
            self.meeting_enabled = false;
          });
        }
    },
    async checkFilestorage() {
      if(this.user.information)
      {
        let self = this;
        await this.$http
          .get(this.user.hostname + "/filestorage/enabled")
          .then(function (result) {
            self.filestorage_enabled = result.data;
          })
          .catch(function () {
            self.filestorage_enabled = false;
          });
      }
    },
    clickedMenu() {
      this.$emit("clickedMenu", true);
    },
    logoutAction() {
      let self = this;
      self.$store.dispatch("user/NotAuthenticated");
      self.$router.push({ name: "Login" }).catch(() => {});
      this.$emit("clickedMenu", true);
      /*this.$http.get(this.user.hostname + "/logout").finally(function() {
        self.$store.dispatch("user/NotAuthenticated");      
         self.$router.push({ name: "Login" });  
      });*/
    },
  },
  computed: {
    organisationImage() {
      return (
        this.user.hostname +
        "/organisation/image/" +
        this.user.information.organisation.id +
        "?uuid=" +
        this.user.information.organisation.image_uuid
      );
    },
    loggedIn() {
      return this.$store.state.user.information;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style>
</style>


